import template from './title.dot';
const titleTemplate = template.default ? template.default : template;
export { titleTemplate };
